export const CLEAR_FILTERS = 'CLEAR_FILTERS';
export const SET_FILTERS = 'SET_FILTERS';

export const TOGGLE_IS_FILTERS_OPEN = 'TOGGLE_IS_FILTERS_OPEN';
